import { InjectionToken } from '@angular/core';
import { LocalCache, StableCache } from '@nk/caching-lib';
import {
  GenderEntity,
  PersonCompanyRoleCompositeEntity,
  PersonCompanyRolePersonFlagCompositeEntity,
  PersonEntity,
  PersonFlagCompositeEntity,
  PersonFlagEntity,
  PersonFlagTypeEntity,
  PersonMasterEntity,
  SimpleCollection,
  WithUuid,
} from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface PersonApiService {
  personCache: LocalCache<PersonApiService, (personUuid: string) => Observable<PersonEntity>>;
  personMasterByPerson: LocalCache<PersonApiService, (personUuid: string) => Observable<PersonMasterEntity[]>>;
  personFlagCompositeByPersonCache: LocalCache<
    PersonApiService,
    (personUuid: string) => Observable<PersonFlagCompositeEntity[]>
  >;
  personCompanyRolePersonFlagListByCompanyCache: LocalCache<
    PersonApiService,
    (
      companyUuid: string,
      currentFlag: boolean,
      companyRoleIdentifiers: string[],
      limit?: number,
      offset?: number,
    ) => Observable<SimpleCollection<PersonCompanyRolePersonFlagCompositeEntity>>
  >;
  personRoleCompositeCollectionByPersonCache: LocalCache<
    PersonApiService,
    (
      personUuid: string,
      companyUuid?: string,
      currentRoles?: boolean,
      limit?: number | null,
      offset?: number | null,
    ) => Observable<SimpleCollection<PersonCompanyRoleCompositeEntity>>
  >;
  personFlagListByPersonCache: LocalCache<PersonApiService, (personUuid: string) => Observable<PersonFlagEntity[]>>;
  personFlagTypeListCache: LocalCache<PersonApiService, () => Observable<PersonFlagTypeEntity[]>>;
  genderListCache: StableCache<PersonApiService, () => Observable<WithUuid<GenderEntity>[]>>;
}
export const PERSON_API_SERVICE_TOKEN = new InjectionToken<PersonApiService>('PersonApiService');
